export class Application {
    applicationId?: number | undefined;
    selectedProgramIds: number[] | undefined;
    selectedProviderIds: number[] | undefined;
    isPersonalInfoComplete: boolean | undefined;
    isBackgroundComplete: boolean | undefined;
    isEducationComplete: boolean | undefined;
    isDisclosureComplete: boolean | undefined;
    isSubmitted: boolean | undefined;
    submitDate?: Date | undefined;

    constructor(options?: Partial<Application>) {
        Object.assign(this, options);
    }
}
